import type { FileForProcessing, ISamplePool } from 'Model/index.js'
import type { ISampleMetaData } from 'Model/Sample/ISampleMetaData.js'

/*
 * For confirm/choose/modal callbacks: they run when the dialog closes, but whatever they captured was read
 * when it opened. Anything written back (a whole metadata row, an item version) must be re-read at that
 * point, or it overwrites what changed in between or fails on a stale version.
 */

/** The store's current copy of each row, by id; a row the store no longer lists is passed through as-is. */
export const currentMetadatas = (stored: ISampleMetaData[], metas: ISampleMetaData[]): ISampleMetaData[] => {
  const byId = new Map(stored.map((metadata) => [metadata.id, metadata]))
  return metas.map((metadata) => byId.get(metadata.id) ?? metadata)
}

export const currentPoolItem = (pools: ISamplePool[] | 'LOADING', itemId: string): FileForProcessing | undefined => {
  if (pools === 'LOADING') {
    return undefined
  }
  return pools.flatMap((pool) => [...pool.samples, ...pool.negativeControls]).find((item) => item.id === itemId)
}

export const currentPool = (pools: ISamplePool[] | 'LOADING', poolId: string): ISamplePool | undefined =>
  pools === 'LOADING' ? undefined : pools.find((pool) => pool.id === poolId)
